/**
 * Create an object that contains error data
 * @param  {Object} error - the error object
 * @return {Object} httpError      [description]
 */
function HttpError(error) {
    const responseText = error.responseText;
    const contentType = error.getResponseHeader("content-type");

    if (error.statusText === "abort" || error.statusText === "timeout") {
        this.type = error.statusText;
    } else {
        this.type = "http";
        this.details = {
            status: error.status,
        };

        if (
            contentType &&
            contentType.indexOf("application/json") === 0 &&
            responseText
        ) {
            this.details.response = JSON.parse(responseText);
        }
    }
}

//Enables bluebird targeted catch
HttpError.prototype = Object.create(Error.prototype);

export default HttpError;
